import { Navigate } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { useAuth } from '../../contexts/auth-context'

export function AdminGuard({ children }) {
	const { user, isAdmin, loading, roleCheckComplete, pendingPasswordReset } = useAuth()

	// Wait for both initial loading and role check to complete
	if (loading || !roleCheckComplete) {
		return (
			<Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
				<CircularProgress />
			</Box>
		)
	}

	if (pendingPasswordReset) {
		return <Navigate to="/reset-password" replace />
	}

	if (!user) {
		return <Navigate to="/auth" replace />
	}

	if (!isAdmin) {
		return <Navigate to="/" replace />
	}

	return children
}
